import Root from '@console/components/projectDraft/Root';
import type { AppState } from '@console/reducers';
import { getSelectedProjectDraftSelectedGiftConfig } from '@console/selectors/getSelectedProjectDraftForDisplay';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  giftConfigs: state.selectedProjectDraft.projectJson.giftConfigs,
  selectedGiftConfig: getSelectedProjectDraftSelectedGiftConfig(state)
});

const mapDispatchToProps = () => ({});

export type RootPropsMappedFromState = ReturnType<typeof mapStateToProps>;
export type RootPropsMappedFromDispatch = ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(Root);
